export const ServiceLevelConsignments = [
    {
        group: [4],
        data:
        {
            name: "Sameday",
            id: 0
        }

    },
    {
        group: [1, 3],
        data:
        {
            name: "Next Day Pre 9:30",
            id: 1
        }
    },
    {
        group: [1, 3],
        data:
        {
            name: 'Next Day Pre 10',
            id: 2
        }
    },
    {
        group: [1, 3],
        data:
        {
            name: "Next Day Pre-noon",
            id: 5
        }

    },
    {
        group: [1, 3],
        data:
        {
            name: "Next Day Saturday",
            id: 6
        }

    },
    {
        group: [0, 1, 3],
        data:
        {
            name: "Next Day Standard",
            id: 7
        }

    },
    {
        group: [1, 3],
        data:
        {
            name: "Saturday Pre 9:30",
            id: 8
        }

    },
    {
        group: [1, 3],
        data:
        {
            name: "Saturday Pre-noon",
            id: 9
        }
    }
]

export const ServiceLeverConsignmentPallet = [
    {
        name: "Next Day Pre 9:30",
        id: 1,
        type: "NextDay"
    },
    {
        name: "Next Day Pre 12:00",
        id: 5,
        type: "NextDay"
    },
    {
        name: "Next Day Standard",
        id: 7,
        type: "NextDay"
    },
    {
        name: "2-3 Working Days",
        id: 10,
        type: "Economy"
    },
    {
        name: "Book In to be done by Depot",
        id: 11,
        type: "NextDay"
    },
    {
        name: "PM Weekday",
        id: 12,
        type: "NextDay"
    },
    {
        name: "Pre-Booked",
        id: 13,
        type: "NextDay"
    },
    {
        name: "Premium Time Specific (9:59 or earlier)",
        id: 14,
        type: "NextDay"
    },
    {
        name: "Premium Timed (09:59 or earlier)",
        id: 15,
        type: "NextDay"
    },
    {
        name: "Saturday PM",
        id: 16,
        type: "NextDay"
    },
    {
        name: "Saturday Timed",
        id: 17,
        type: "NextDay"
    },
    {
        name: "Time Specific (10am or after)",
        id: 18,
        type: "NextDay"
    },
    {
        name: "Timed Delivery (10am or after)",
        id: 19,
        type: "NextDay"
    },
    {
        name: "Next Day PM",
        id: 20,
        type: "NextDay"
    },
    {
        name: "Northern Ireland & Highlands",
        id: 21,
        type: "NextDay",
    },
    {
        name: "Offshore & Channel Islands",
        id: 22,
        type: "NextDay",
    },
    {
        name: "Residential Surcharge",
        id: 23,
        type: "NextDay",
    }
]

export const ServiceLeverConsignmentPalletCust = [
  {
    name: "Next Day Pre 9:30",
    id: 1,
    type: "NextDay"
  },
  {
    name: "Next Day Pre 12:00",
    id: 5,
    type: "NextDay"
  },
  {
    name: "Next Day Standard",
    id: 7,
    type: "NextDay"
  },
  //{
  //  name: "2-3 Working Days",
  //  id: 10,
  //  type: "Economy"
  //},
  //{
  //  name: "Book In to be done by Depot",
  //  id: 11,
  //  type: "NextDay"
  //},
  //{
  //  name: "PM Weekday",
  //  id: 12,
  //  type: "NextDay"
  //},
  //{
  //  name: "Pre-Booked",
  //  id: 13,
  //  type: "NextDay"
  //},
  //{
  //  name: "Premium Time Specific (9:59 or earlier)",
  //  id: 14,
  //  type: "NextDay"
  //},
  //{
  //  name: "Premium Timed (09:59 or earlier)",
  //  id: 15,
  //  type: "NextDay"
  //},
  //{
  //  name: "Saturday PM",
  //  id: 16,
  //  type: "NextDay"
  //},
  //{
  //  name: "Saturday Timed",
  //  id: 17,
  //  type: "NextDay"
  //},
  //{
  //  name: "Time Specific (10am or after)",
  //  id: 18,
  //  type: "NextDay"
  //},
  //{
  //  name: "Timed Delivery (10am or after)",
  //  id: 19,
  //  type: "NextDay"
  //},
  //{
  //  name: "Next Day PM",
  //  id: 20,
  //  type: "NextDay"
  //},
  //{
  //  name: "Northern Ireland & Highlands",
  //  id: 21,
  //  type: "NextDay",
  //},
  //{
  //  name: "Offshore & Channel Islands",
  //  id: 22,
  //  type: "NextDay",
  //},
  //{
  //  name: "Residential Surcharge",
  //  id: 23,
  //  type: "NextDay",
  //}
]

export const ServiceLeverConsignmentPackage = [
    {
        name: "Next Day Pre 9:30",
        id: 1,
        type: "NextDay"
    },
    {
        name: "Economy",
        id: 3,
        type:"NextDay"
    },
    {
        name: "Next Day 10",
        id: 2,
        type: "NextDay"
    },
    {
        name: "Next Day Pre 12:00",
        id: 5,
        type: "NextDay"
    },
    {
        name: "Next Day Saturday",
        id: 6,
        type: "NextDay"
    },
    {
        name: "Next Day Standard",
        id: 7,
        type: "NextDay"
    },
    {
        name: "Saturday Pre 9:30",
        id: 8,
        type: "NextDay"
    },
    {
        name: "Saturday Pre-noon",
        id: 9,
        type: "NextDay"
    },
]

export const ServiceLeverConsignmentPackageCust = [
  {
    name: "Next Day Pre 9:30",
    id: 1,
    type: "NextDay"
  },
  //{
  //  name: "Economy",
  //  id: 3,
  //  type: "NextDay"
  //},
  {
    name: "Next Day Pre 12:00",
    id: 5,
    type: "NextDay"
  },
  {
    name: "Next Day Standard",
    id: 7,
    type: "NextDay"
  }
  //{
  //  name: "Next Day Saturday",
  //  id: 6,
  //  type: "NextDay"
  //},
 
  //{
  //  name: "Saturday Pre 9:30",
  //  id: 8,
  //  type: "NextDay"
  //},
  //{
  //  name: "Saturday Pre-noon",
  //  id: 9,
  //  type: "NextDay"
  //},
]

export function getConsignmentServiceLevelById(id: number): string {
    const result = ServiceLeverConsignmentPackage.concat(ServiceLeverConsignmentPallet).find(s => s.id === id);
    return result ? result.name : undefined;
}
